import { createAction } from '@reduxjs/toolkit';
import {
  ClearContentTypes,
  EventBusReceiveMessage,
  InteractionKind,
  RedirectPayload,
  SignalingDisconnectPayload,
} from 'features/application/types';
import { SignalingPong, SystemUpdatePayload } from 'services/signaling';

export const redirect = createAction<RedirectPayload>('application/redirect');

export const RTCClientInitialized = createAction('application/RTCClientInitialized');

export const signalingConnected = createAction('signaling/application/connected');
export const pong = createAction<SignalingPong>('signaling/application/pong');

export const systemUpdate = createAction<SystemUpdatePayload>('signaling/application/systemUpdate');

export const signalingDisconnected = createAction<SignalingDisconnectPayload>(
  'signaling/application/disconnected'
);
export const signalingReconnected = createAction('signaling/application/reconnected');

export const eventBusCommandReceived = createAction<EventBusReceiveMessage>(
  'eventBus/commandReceived'
);

export const interactionTriggered = createAction<InteractionKind>(
  'application/interactionTriggered'
);

export const languageChangeRequested = createAction<string>('application/languageChangeRequested');

export const audioOnlyModeToggleRequested = createAction(
  'application/audioOnlyModeToggleRequested'
);

export const clearContentRequested = createAction<ClearContentTypes>(
  'application/clearContentRequested'
);
export const signalingContentCleared = createAction<ClearContentTypes>(
  'signaling/application/contentCleared'
);
